import { Add, Close } from '@mui/icons-material';
import React, { useEffect, useMemo, useState } from "react";
import { resource_types } from "store/extraResource/constants";
import styled from "styled-components";
import EditResourceType from "./type/resource";
import { Button, Modal } from '@mui/material';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import { Col, Row } from "antd";
import { map } from "lodash";
import CoversCardList from "./type/resource/coverCardList";
import StoryLevelsExtensionActivity from "./type/1wayStory";
import BookUnitsExtraResource from "./type/bookUnits";
import ListAllAPExtraResource from "./type/AP";

const ResourceTypeSelector = ({ data, type, pageId, handleSubmit, config, modalZIndex = 1500 }) => {
  const theme = useTheme();
  const overlayMenuTheme = useMemo(
    () =>
      createTheme({
        ...theme,
        zIndex: {
          ...theme.zIndex,
          modal: modalZIndex + 500,
        },
      }),
    [theme, modalZIndex],
  );
  const [open, setOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const { resource, story, balcon, conectándome, comunidad, informate, AP } =
    resource_types;

  useEffect(() => {
    setSelectedItems(data);
  }, [data]);

  const handleOnClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal open={open} onClose={handleOnClose} sx={{ zIndex: modalZIndex }}>
        <ModalContent>
          <CloseButton
            onClick={() => setOpen(false)}
            className="transition cursor-pointer p-0"
          >
            <Close color="secondary" />
          </CloseButton>
          <ThemeProvider theme={overlayMenuTheme}>
            {(() => {
              switch (type) {
                case resource:
                  return (
                    <EditResourceType
                      from="extraResource"
                      handleSubmit={async (data, linkResource) => {
                        await handleSubmit(data, linkResource);
                        setSelectedItems(data);
                        handleOnClose();
                      }}
                      items={selectedItems}
                      config={config}
                      id={pageId}
                    />
                  );
                case story:
                  return (
                    <StoryLevelsExtensionActivity
                      from="extraResource"
                      handleSubmit={async (data, level) => {
                        await handleSubmit(data, level);
                        setSelectedItems(data);
                      }}
                      items={selectedItems}
                      config={config}
                      pageId={pageId}
                      handleOnClose={handleOnClose}
                    />
                  );
                case balcon:
                  return (
                    <BookUnitsExtraResource
                      balconId={"33"}
                      from="extraResource"
                      handleSubmit={async (data) => {
                        await handleSubmit(data);
                        setSelectedItems(data);
                        handleOnClose();
                      }}
                      items={selectedItems}
                      pageId={pageId}
                    />
                  );
                case conectándome:
                  return (
                    <BookUnitsExtraResource
                      balconId={"49"}
                      from="extraResource"
                      handleSubmit={async (data) => {
                        await handleSubmit(data);
                        setSelectedItems(data);
                        handleOnClose();
                      }}
                      items={selectedItems}
                      pageId={pageId}
                    />
                  );
                case comunidad:
                  return (
                    <BookUnitsExtraResource
                      balconId={"43"}
                      from="extraResource"
                      handleSubmit={async (data) => {
                        await handleSubmit(data);
                        setSelectedItems(data);
                        handleOnClose();
                      }}
                      items={selectedItems}
                      pageId={pageId}
                    />
                  );
                case informate:
                  return (
                    <BookUnitsExtraResource
                      balconId={"41"}
                      from="extraResource"
                      handleSubmit={async (data) => {
                        await handleSubmit(data);
                        setSelectedItems(data);
                        handleOnClose();
                      }}
                      items={selectedItems}
                      pageId={pageId}
                    />
                  );
                case AP:
                  return (
                    <ListAllAPExtraResource
                      id={"69"}
                      from="extraResource"
                      handleSubmit={async (data, categoryData) => {
                        await handleSubmit(data, categoryData);
                        setSelectedItems(data);
                        handleOnClose();
                      }}
                      items={selectedItems}
                      config={config}
                      pageId={pageId}
                    />
                  );
                default:
                  return null;
              }
            })()}
          </ThemeProvider>
        </ModalContent>
      </Modal>
      <Button
        variant="contained"
        color="primary"
        startIcon={<Add />}
        onClick={() => setOpen(true)}
      >
        {selectedItems?.length > 0 ? "Edit Section" : "Add Section"}{" "}
      </Button>

      {type === resource && (
        <Row
          style={{ marginTop: "10px", maxHeight: "500px", overflowY: "auto" }}
        >
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <ListCovers>
              {map(selectedItems, (podcast) => (
                <ListItemCovers key={podcast.id}>
                  <CoversCardList
                    data={podcast}
                    onClick={() => {}}
                    onDelete={() => {}}
                    selectionResource={true}
                    selectedItem={[]}
                  />
                </ListItemCovers>
              ))}
            </ListCovers>
          </Col>
        </Row>
      )}

      {type === story && (
        <GridContainer>
          {map(selectedItems, (podcast) => (
            <div className="ImgBtn">
              <label style={{ height: "44px" }}>
                {podcast?.title || "title"}
              </label>
              <div>
                <img src={podcast?.img} />
              </div>
            </div>
          ))}
        </GridContainer>
      )}

      {(type === balcon ||
        type === comunidad ||
        type === conectándome ||
        type === informate ||
        type === AP) && (
        <GridContainer>
          {map(selectedItems, (podcast, i) => (
            <div key={i} className="card-resource">
              <a>
                <div className="card-resource-overlay"></div>
                <Image
                  className="card-resource-image"
                  src={podcast.src}
                  alt={podcast.shortName}
                />
                <div className="card-resource-details fadeIn-bottom">
                  <h3 className="card-resource-title">{podcast.shortName}</h3>
                </div>
              </a>
            </div>
          ))}
        </GridContainer>
      )}
    </>
  );
};

export default ResourceTypeSelector;

const Image = styled.img`
  width: 100%;
  min-height: 220px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); // 2 items per row
  gap: 10px;
  width: 100%;
  margin-top: 10px;
  max-height: 500px;
  overflow-y: auto;
`;

const ListItemCovers = styled.li`
  margin: 0px 16px 32px;
  width: calc(50% - 32px);
`;

const ListCovers = styled.ul`
  height: auto;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style-type: none;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
`;

const ModalContent = styled.div`
  overflow: auto;
  overflow-x: hidden;
  left: 50%;
  width: 95%;
  position: absolute;
  height: 93vh;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  transition: all 0.3s ease-in-out;
`;
